export default __webpack_public_path__ + "static/media/note-gray.1ad71db6.svg";